import { createThumbnailFromBat } from '@/littleWedding/canvasMaterialsManager';
import type { ITextField } from '@/typescript/interfaces/ITextField';
import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { ITemplate } from '@/typescript/interfaces/ITemplate';
import type { WFabricWorld } from '@/littleWedding/WFabricWorld';

async function screenshot({ fabricWorld, selectedTemplate }: { fabricWorld: WFabricWorld; selectedTemplate: ITemplate }) {
    const filteredFields = selectedTemplate.configuration.fields.filter(
        (filteredField) =>
            filteredField.transform.position.x + filteredField.transform.position.y !== 0 ||
            (filteredField as IImageField)?.url !== undefined ||
            (filteredField as ITextField)?.text !== undefined,
    );
    if (!filteredFields.length) return;

    const screenShot: Blob | undefined = await createThumbnailFromBat({
        fabricWorld,
    });

    if (screenShot === undefined) {
        console.error(screenShot);
        return;
    }
    const namePrefix = 'little_wedding_template_';
    const extension = `.jpg`;
    const now = new Date();
    const date = now.toISOString().split('T')[0];
    const time = `${now.getHours()}h-${now.getMinutes()}m-${now.getSeconds()}s`;
    const nameSuffix = `${date}_${time}`;

    const a = document.createElement('a');
    const url = URL.createObjectURL(screenShot);
    a.href = url;
    a.download = `${namePrefix}${nameSuffix}${extension}`;
    a.click();
}

export { screenshot };
